// extracted by mini-css-extract-plugin
export var quantityInput = "_e8-0";